// src/navigation/wrappers/AdminNavigationWrapper.jsx
import React from 'react';
import AdminNav from '../../components/AdminNav';
import AdminTopMenuBar from '../../components/AdminTopMenuBar';
import AdminMobileBottomNav from '../../components/AdminMobileBottomNav';
import UniversalFooter from '../../components/UniversalFooter';

const AdminNavigationWrapper = ({ children }) => {
  return (
    <>
      <AdminNav />
      <AdminTopMenuBar />
      {children}
      <AdminMobileBottomNav />
      <UniversalFooter />
    </>
  );
};

export default AdminNavigationWrapper;
